import _cloneDeep from 'lodash/cloneDeep';

export default {
  fundAllocation: (state) => _cloneDeep(state.fundAllocation),
  fundAllocations: (state) => _cloneDeep(state.fundAllocations),
};
